import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Neue Farbpalette für IT-Beratung Reinke */
    --primary-color: #003366; /* Alpenblau */
    --secondary-color: #5E6A75; /* Felsgrau */
    --accent-color: #FFB400; /* Gipfelgold */
    --background-color: #F8F9FA; /* Schneeweiß */
    --text-color: #212529; /* Standard-Textfarbe */
    
    /* Zusätzliche Farben für bessere Kontraste */
    --background-light: #FFFFFF;
    --background-dark: #E9ECEF;
    --text-secondary: #6C757D;
    --primary-light: #004080;
    --primary-dark: #002347;
    --accent-light: #FFC233;
    --accent-dark: #E6A200;
    --error: #DC3545;
    --success: #28A745;
    --warning: #FFC107;
    --info: #17A2B8;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--background-color);
    color: var(--text-color);
    line-height: 1.6;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(--text-color);
    line-height: 1.2;
    font-weight: 700; /* Bold für alle Überschriften */
  }

  p {
    margin-bottom: 1rem;
    font-weight: 400; /* Regular für Fließtext */
  }

  a {
    color: var(--primary-color);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: var(--primary-light);
    }
  }

  button {
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ::selection {
    background-color: var(--accent-color);
    color: var(--background-color);
  }

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: var(--background-dark);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--secondary-color);
    border-radius: 6px;
    border: 3px solid var(--background-dark);

    &:hover {
      background: var(--primary-color);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .fadeIn {
    animation: fadeIn 0.6s ease forwards;
  }

  /* Neue Utility-Klassen für die IT-Beratung Reinke */
  .text-primary { color: var(--primary-color); }
  .text-secondary { color: var(--secondary-color); }
  .text-accent { color: var(--accent-color); }
  .bg-primary { background-color: var(--primary-color); }
  .bg-secondary { background-color: var(--secondary-color); }
  .bg-accent { background-color: var(--accent-color); }
  .bg-light { background-color: var(--background-light); }
`;

export default GlobalStyles; 